import i18n from "@/plugins/i18n";
import type { StopInfoSeal } from "@/types/trip";

const t = i18n.global.t;

class SealValidator {
  #seals;

  constructor(seals: StopInfoSeal[]) {
    this.#seals = seals;
  }

  validate(): Record<string, string | null> {
    return Object.fromEntries(
      this.#seals.map((seal, index) => {
        const error = this.#isDuplicated(seal, index)
          ? t("trip.seal-duplicate-on-travel-order", { id: seal.travelOrderId })
          : null;

        return [seal.tempId, error];
      }),
    );
  }

  #isDuplicated(seal: StopInfoSeal, index: number): boolean {
    const number = seal.number.trim();

    if (!number) {
      return false;
    }

    return this.#seals.some((otherSeal, otherIndex) => {
      return (
        otherIndex < index && otherSeal.travelOrderId === seal.travelOrderId && otherSeal.number.trim() === number
      );
    });
  }
}

export default SealValidator;
